export const HELP_DESK_LINKS = {
  amityage: 'https://amityage.zendesk.com/hc/en-us',
  pantheon: 'https://pantheonmining.zendesk.com/hc/en-us',
  'pantheon-aus': 'https://pantheonmining.zendesk.com/hc/en-us',
  paymine: 'https://paymine.zendesk.com/hc/en-us'
};
